<template>

  <inventory-calendar-popup :title="$t('titles.entire_location')">

    <div class="d-flex justify-space-between">
      <div>
        {{ Temporal.PlainDateTime.from(item.start).toPlainTime().toLocaleString(undefined, {timeStyle: 'short'}) }} –
        {{ Temporal.PlainDateTime.from(item.end).toPlainTime().toLocaleString(undefined, {timeStyle: 'short'}) }}
      </div>
      <div class="text-end">
        {{ item.spacesSold }}/{{ item.spacesTotal }}
      </div>
    </div>

  </inventory-calendar-popup>

</template>

<script setup lang="ts">

// components
import InventoryCalendarPopup from './InventoryCalendarPopup.vue'
import type { DaySummaryInventoryCalendarItem } from '../calendarItemTypes'

// models
interface Props {
  item: DaySummaryInventoryCalendarItem
}

// misc
import { Temporal } from '@js-temporal/polyfill'

defineProps<Props>()

</script>
